import { Box, Typography } from '@mui/material';

export const Nav = () => (
  <Box
    id="navbar-navigation"
    sx={{
      padding: '8px 16px',
      height: '61px',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <div className="mr-auto d-flex">
      <Typography component="h5" variant="h5">
        Customize LCI Report
      </Typography>
    </div>
  </Box>
);
